(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["labosch-whatsapp-widget"] && !Shopify.designMode) return;
  try {
    (function () {
  function parseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function formatVariantOptions(variant, optionNames) {
    if (!variant || !Array.isArray(variant.options)) return '';

    return variant.options.map(function (value, index) {
      var rawValue = String(value || '').trim();
      var optionName = String((optionNames && optionNames[index]) || '').trim();
      var normalisedName = optionName.toLowerCase();

      if (!rawValue || /^default title$/i.test(rawValue)) return '';

      if (/talla|size|taille|gr[oö]ße|taglia|tamanho/.test(normalisedName)) {
        return optionName ? optionName + ' ' + rawValue : rawValue;
      }

      if (/bater|battery|batterie|akku/.test(normalisedName)) {
        return /wh$/i.test(rawValue) ? rawValue : rawValue + ' Wh';
      }

      return rawValue;
    }).filter(Boolean).join(' - ');
  }

  function initWidget(widget) {
    if (!widget || widget.dataset.lbxWhatsappReady === 'true') return;
    widget.dataset.lbxWhatsappReady = 'true';

    var link = widget.querySelector('[data-lbx-whatsapp-link]');
    var config = parseJson(widget.querySelector('[data-lbx-whatsapp-config]'), {});
    var variants = parseJson(widget.querySelector('[data-lbx-whatsapp-variants]'), []);
    var variantMap = {};

    if (!link || !config.phone) return;

    variants.forEach(function (variant) {
      if (variant && variant.id != null) variantMap[String(variant.id)] = variant;
    });

    function currentVariantId() {
      try {
        var fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (fromUrl) return String(fromUrl);
      } catch (error) {}

      if (widget.dataset.lbxWhatsappVariantId) {
        return String(widget.dataset.lbxWhatsappVariantId);
      }

      var variantInputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (var index = 0; index < variantInputs.length; index += 1) {
        if (variantInputs[index].value) return String(variantInputs[index].value);
      }

      return config.initialVariantId != null ? String(config.initialVariantId) : '';
    }

    function exactPageUrl(variantId) {
      try {
        var url = new URL(window.location.href);
        if (config.productTitle && variantId) url.searchParams.set('variant', variantId);
        return url.toString();
      } catch (error) {
        return window.location.href;
      }
    }

    function buildMessage() {
      var variantId = currentVariantId();
      var variant = variantMap[variantId] || null;
      var lines = [String(config.baseMessage || '').trim()];

      if (config.productTitle) {
        var productTitle = String(config.productTitle).trim();
        var vendor = String(config.productVendor || '').trim();
        var productLine = productTitle;
        if (vendor && productTitle.toLowerCase().indexOf(vendor.toLowerCase()) === -1) {
          productLine = vendor + ' ' + productTitle;
        }
        var variantTitle = formatVariantOptions(variant, config.optionNames || []);
        if (variantTitle) productLine += ' - ' + variantTitle;
        lines.push('', productLine);
      } else if (config.pageTitle) {
        lines.push('', String(config.pageTitle).trim());
      }

      lines.push(exactPageUrl(variantId));
      return lines.filter(function (line, index) {
        return line !== '' || index > 0;
      }).join('\n');
    }

    function refreshHref() {
      link.href = 'https://wa.me/' + encodeURIComponent(String(config.phone)) + '?text=' + encodeURIComponent(buildMessage());
    }

    function captureVariant(event) {
      var detail = event && event.detail ? event.detail : {};
      var variant = detail.variant || detail.selectedVariant || detail.currentVariant;
      if (variant && variant.id != null) widget.dataset.lbxWhatsappVariantId = String(variant.id);
      window.setTimeout(refreshHref, 0);
    }

    document.addEventListener('variant:change', captureVariant);
    document.addEventListener('variant:changed', captureVariant);
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('form[action*="/cart/add"] [name="id"]') && target.value) {
        widget.dataset.lbxWhatsappVariantId = String(target.value);
        window.setTimeout(refreshHref, 0);
      }
    }, true);

    window.addEventListener('popstate', refreshHref);
    link.addEventListener('pointerdown', refreshHref);
    link.addEventListener('click', refreshHref);
    refreshHref();
  }

  function boot() {
    document.querySelectorAll('[data-lbx-whatsapp-widget]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
